import { createGenericReducer } from "common/genericReducer";
import { MENU_RECEIVED, MENU_REQUESTED, MENU_REQUEST_FAILED } from "./menuActions";

export const menu = createGenericReducer(MENU_REQUESTED, MENU_RECEIVED, MENU_REQUEST_FAILED);
